import _ from 'lodash'
import { isNotUndefined } from '../helpers/types'
import { isHavingProps } from '../helpers/object'
import { sortByObjectProp } from '../helpers/array'

export const getProductCategoriesAllLevels = (
  data = undefined,
  categoryListFlatten = [],
  categoriesNested = [],
  productDistributor = false
) => {
  const genericName = {
    id: null,
    name: '',
    parentId: null,
  }
  const subCategory = {
    id: null,
    name: '',
    parentId: null,
  }
  const rootCategory = {
    id: null,
    name: '',
  }
  if (isNotUndefined(data)) {
    if (productDistributor)
      return getDistributorProductCategoriesAllLevels(data, {
        genericName,
        subCategory,
        rootCategory,
      })
    else
      return getProductModelCategoriesAllLevels(
        data,
        categoryListFlatten,
        categoriesNested,
        {
          genericName,
          subCategory,
          rootCategory,
        }
      )
  }
  return {
    genericName,
    subCategory,
    rootCategory,
  }
}

export const getRootAndSubcategoryByGenericNameId = (
  subCategoryId = null,
  categoryListFlatten = [],
  categoriesNested = []
) => {
  const parents = {
    subCategory: {
      id: null,
      name: '',
      parentId: null,
    },
    rootCategory: {
      id: null,
      name: '',
    },
  }
  if (!subCategoryId) return parents

  const subcategoryList = categoryListFlatten.filter((item) => item.level === 2)
  const subCategoryIndex = subcategoryList.findIndex(
    (subcategory) => parseInt(subcategory.id) === parseInt(subCategoryId)
  )
  if (subCategoryIndex !== -1) {
    const subCategory = subcategoryList[subCategoryIndex]
    const rootCategoryId = subCategory?.parentId.toString()
    parents.subCategory = {
      id: subCategoryId,
      name: subCategory?.name ?? '',
      parentId: rootCategoryId ?? null,
    }
    if (isNotUndefined(rootCategoryId) && rootCategoryId !== null) {
      const rootCategoryIndex = categoriesNested.findIndex(
        (rootCategory) => parseInt(rootCategory.id) === parseInt(rootCategoryId)
      )
      if (rootCategoryIndex !== -1) {
        const rootCategory = categoriesNested[rootCategoryIndex]
        parents.rootCategory = {
          id: rootCategoryId,
          name: rootCategory?.name ?? '',
        }
      }
    }
  }
  return parents
}

export const getRootCategoryById = (
  rootCategoryId = null,
  categoriesNested = []
) => {
  if (isNotUndefined(rootCategoryId) && rootCategoryId !== null) {
    const rootCategoryIndex = categoriesNested.findIndex(
      (rootCategory) => parseInt(rootCategory.id) === parseInt(rootCategoryId)
    )
    if (rootCategoryIndex !== -1) {
      const rootCategory = categoriesNested[rootCategoryIndex]
      return {
        id: rootCategoryId,
        name: rootCategory?.name ?? '',
      }
    }
  }
  return {
    id: null,
    name: '',
  }
}

export const getProductModelCategoriesAllLevels = (
  data,
  categoryListFlatten,
  categoriesNested,
  { genericName, subCategory, rootCategory }
) => {
  const level = data?.level
  if (level === 3) {
    let parentId = data?.parentId ?? null
    if (parentId) parentId = parentId.toString()
    genericName = {
      id: data?.id ?? null,
      name: data?.name ?? '',
      parentId,
    }
    if (isNotUndefined(data?.parent?.data)) {
      const subCategoryData = data.parent.data
      if (isNotUndefined(subCategoryData)) {
        const subCategoryId = isNotUndefined(data?.parentId)
          ? data.parentId.toString()
          : null
        const rootCategoryId = isNotUndefined(subCategoryData?.parentId)
          ? subCategoryData.parentId.toString()
          : null
        subCategory = {
          id: subCategoryId,
          name: subCategoryData?.name ?? '',
          parentId: rootCategoryId,
        }
        const rootCategoryData = subCategoryData?.parent?.data
        if (
          isNotUndefined(rootCategoryData && isHavingProps(rootCategoryData))
        ) {
          rootCategory = {
            id: rootCategoryId,
            name: rootCategoryData?.name ?? '',
          }
        } else {
          rootCategory = getRootCategoryById(rootCategoryId, categoriesNested)
        }
      }
    } else {
      const parents = getRootAndSubcategoryByGenericNameId(
        parentId,
        categoryListFlatten,
        categoriesNested
      )
      if (parents && isHavingProps(parents)) {
        subCategory = parents.subCategory
        rootCategory = parents.rootCategory
      }
    }
  }
  if (level === 2) {
    const parentId = isNotUndefined(data?.parentId)
      ? data.parentId.toString()
      : null
    subCategory = {
      id: data?.id ?? null,
      name: data?.name ?? '',
      parentId,
    }
    if (isNotUndefined(data?.parent?.data)) {
      const rootCategoryData = data.parent.data
      rootCategory = {
        id: parentId,
        name: rootCategoryData?.name ?? '',
      }
    } else {
      rootCategory = getRootCategoryById(parentId, categoriesNested)
    }
  }
  if (level === 1) {
    rootCategory = {
      id: data?.id ?? null,
      name: data?.name ?? '',
    }
  }
  return {
    genericName,
    subCategory,
    rootCategory,
  }
}

export const getDistributorProductCategoriesAllLevels = (
  data,
  { genericName, subCategory, rootCategory }
) => {
  const level = data?.level
  if (level === 1) {
    rootCategory = {
      id: isNotUndefined(data?._jv?.id) ? data._jv.id : null,
      name: data?.name ?? '',
    }
  } else if (level === 2) {
    const rootCategoryData = data?.parent
    const categoryId = isNotUndefined(data?.parentId) ? data.parentId : null
    subCategory = {
      id: isNotUndefined(data?._jv?.id) ? data._jv.id : null,
      name: data?.name ?? '',
      parentId: categoryId,
    }
    rootCategory = {
      id: categoryId,
      name: rootCategoryData?.name ?? '',
    }
  } else if (level === 3) {
    const subCategoryData = data?.parent
    const rootCategoryData = subCategoryData?.parent
    if (isNotUndefined(subCategoryData)) {
      const subCategoryId = isNotUndefined(data?.parentId)
        ? data.parentId
        : null
      const rootCategoryId = isNotUndefined(subCategoryData?.parentId)
        ? subCategoryData.parentId
        : null
      genericName = {
        id: isNotUndefined(data?._jv?.id) ? data._jv.id : null,
        name: data?.name ?? '',
        parentId: subCategoryId,
      }
      subCategory = {
        id: subCategoryId,
        name: subCategoryData?.name ?? '',
        parentId: rootCategoryId,
      }
      rootCategory = {
        id: rootCategoryId,
        name: rootCategoryData?.name ?? '',
      }
    }
  }
  return {
    genericName,
    subCategory,
    rootCategory,
  }
}

export const getCategory = (categoryList) => {
  let category = categoryList.filter((el) => el.parentId === null)
  const sub = categoryList.filter((el) => el.parentId !== null)
  category = _.map(category, (category) => {
    const children = sub.filter(
      (sub) => parseInt(category.id) === parseInt(sub.parentId)
    )
    return {
      ...category,
      children,
    }
  })
  return category.sort()
}

export const getCategoryWithGeneric = (categoryList, maxLevel = 3) => {
  let level = 1
  const list = []
  const levelsList = []
  for (level; level <= maxLevel; level++) {
    const cat = categoryList.filter((el) => el.level === level)
    sortByObjectProp(cat, 'name')
    levelsList.push(cat)
  }
  levelsList.forEach((levelList, index) => {
    if (index === 0) {
      list.push(...levelList)
    }
    if (index === 1) {
      const rootArray = levelsList[index - 1]
      levelList.forEach((cat) => {
        rootArray.forEach((rootCat) => {
          if (parseInt(cat.parentId) === parseInt(rootCat.id)) {
            const findIndex = list.findIndex(
              (item) => parseInt(item.id) === parseInt(rootCat.id)
            )
            if (findIndex !== -1) {
              const rootCat = list[findIndex]
              if (isHavingProps(rootCat)) {
                if (isNotUndefined(rootCat?.children)) {
                  const children = rootCat.children
                  children.push(cat)
                  list[findIndex].children = children
                } else {
                  list[findIndex].children = [cat]
                }
              }
            }
          }
        })
      })
    }
    if (index === 2) {
      const rootArray = levelsList[index - 1]
      levelList.forEach((cat) => {
        rootArray.forEach((rootCat) => {
          if (parseInt(cat.parentId) === parseInt(rootCat.id)) {
            let findIndex = -1
            let childIndex = -1
            let listIndex = 0
            for (listIndex; listIndex < list.length; listIndex++) {
              const children = list[listIndex]?.children
              if (isNotUndefined(children)) {
                childIndex = children.findIndex((child) => {
                  return parseInt(child?.id) === parseInt(rootCat.id)
                })
                if (childIndex !== -1) {
                  findIndex = listIndex
                  break
                }
              }
            }
            if (findIndex !== -1 && childIndex !== -1) {
              const rootCat = list?.[findIndex]?.children?.[childIndex]
              if (isHavingProps(rootCat)) {
                if (isNotUndefined(rootCat?.children)) {
                  const children = rootCat.children
                  children.push(cat)
                  list[findIndex].children[childIndex].children = children
                } else {
                  list[findIndex].children[childIndex].children = [cat]
                }
              }
            }
          }
        })
      })
    }
  })
  return list
}

export const mapCategories = (list = []) => {
  return {
    rootCategory: list?.root
      ? {
          ...list.root,
          id: list?.root?.id ? list.root.id.toString() : null,
        }
      : {},
    subCategory: list?.sub
      ? {
          ...list.sub,
          id: list?.sub?.id ? list.sub.id.toString() : null,
          parent_id: list?.sub?.parent_id
            ? list.sub.parent_id.toString()
            : null,
        }
      : {},
    genericName: list?.generic
      ? {
          ...list.generic,
          id: list?.generic?.id ? list.generic.id.toString() : null,
          parent_id: list?.generic?.parent_id
            ? list.generic.parent_id.toString()
            : null,
        }
      : {},
  }
}
